import React, { useEffect, useRef, useState } from "react";
import { ActivityIndicator, Text, TouchableOpacity, View } from "react-native";
import ThemeProvider from "@voltmoney/theme";
import { ColorTokens, IconSizeTokens, IconTokens, SizeTypeTokens, TypographyTypeDLS, } from "@voltmoney/schema";
import { Typography } from "../../../typography/Typography";
import { Space } from "../../../space/Space";
import { OtpInput } from "../../OtpInput/OtpInput";
import { Icon } from "../../../icon/Icon";
const CgtcOtpPage = ({ show = true, phoneNumber, verifyAction, resendAction, editAction, isError, otpErrorMessage, onChangeAction, triggerAction }) => {
    const theme = ThemeProvider.getTheme();
    const colorMapping = theme.colors;
    const inputRef = useRef(null);
    const [isErrorState, setIsErrorState] = useState(isError);
    const [otpLoading, setOtpLoading] = useState(false);
    const [isResendAllowed, setIsResendAllowed] = useState(true);
    const RESEND_TIME = 60;
    const [resendTimer, setResendTimer] = useState(RESEND_TIME);
    const [otpKey, setOtpKey] = useState(Math.random());
    let timerInterval;
    const startTimer = () => {
        //Reset
        setResendTimer(RESEND_TIME);
        setIsResendAllowed(false);
        //Set
        if (!timerInterval) {
            timerInterval = setInterval(() => {
                setResendTimer(resendTimer => resendTimer - 1);
            }, 1000);
        }
    };
    useEffect(() => {
        startTimer();
        return () => {
            timerInterval &&
                clearInterval(timerInterval);
        };
    }, []);
    useEffect(() => {
        if (resendTimer === 1) {
            clearInterval(timerInterval);
            setResendTimer(RESEND_TIME);
            setIsResendAllowed(true);
        }
    }, [resendTimer]);
    useEffect(() => {
        setIsErrorState(isError);
    }, [
        isError,
        otpErrorMessage
    ]);
    return (React.createElement(View, { key: otpKey, style: [
            styles.container,
            {
                width: '100%',
                padding: 24,
                backgroundColor: colorMapping[ColorTokens.White]
            }
        ] },
        React.createElement(Typography, { label: 'MFCentral has sent an OTP', typeDLS: TypographyTypeDLS.H4S, color: ColorTokens.Grey_Night }),
        React.createElement(Space, { size: SizeTypeTokens.SM }),
        React.createElement(Text, null,
            React.createElement(Typography, { label: `OTP sent to ${phoneNumber}  `, typeDLS: TypographyTypeDLS.B2S, color: ColorTokens.Grey_Charcoal }),
            React.createElement(TouchableOpacity, { onPress: async () => {
                    editAction &&
                        await triggerAction(editAction);
                } },
                React.createElement(Typography, { label: 'Edit', typeDLS: TypographyTypeDLS.B2S, color: ColorTokens.Primary_100 }))),
        React.createElement(Space, { size: SizeTypeTokens.XXXL }),
        React.createElement(OtpInput, { numberOfDigits: 6, 
            // ref={inputRef}
            editable: !otpLoading, onTextChange: async (text) => {
                if (text.length === 6) {
                    setOtpLoading(true);
                    if (verifyAction) {
                        await triggerAction({
                            ...verifyAction,
                            payload: {
                                otp: text,
                            },
                        });
                    }
                    setOtpLoading(false);
                }
                else {
                    onChangeAction &&
                        await triggerAction(onChangeAction);
                }
            }, focusColor: isErrorState
                ? colorMapping[ColorTokens.System_Error]
                : colorMapping[ColorTokens.Primary_100], theme: {
                inputsContainerStyle: {
                    width: 47,
                    height: 47,
                    borderRadius: 0,
                },
                pinCodeContainerStyle: { borderRadius: 8 },
                pinCodeTextStyle: { fontSize: 15 },
                containerStyle: { width: 300 },
            } }),
        otpLoading &&
            React.createElement(View, { style: {
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    position: 'relative',
                    top: 20
                } },
                React.createElement(ActivityIndicator, { color: colorMapping[ColorTokens.Primary_100], size: "small" }),
                React.createElement(Space, { size: SizeTypeTokens.MD }),
                React.createElement(Typography, { label: 'Verifying OTP', typeDLS: TypographyTypeDLS.B2R, color: ColorTokens.Primary_100 })),
        isErrorState &&
            otpErrorMessage &&
            React.createElement(View, { style: {
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    position: 'relative',
                    top: 20
                } },
                React.createElement(Typography, { label: otpErrorMessage, typeDLS: TypographyTypeDLS.B2R, color: ColorTokens.System_Error })),
        React.createElement(Space, { size: SizeTypeTokens.XXXL }),
        isResendAllowed ?
            React.createElement(TouchableOpacity, { onPress: async () => {
                    setOtpKey(Math.random());
                    startTimer();
                    resendAction &&
                        await triggerAction(resendAction);
                } },
                React.createElement(Text, null,
                    React.createElement(Typography, { label: `Didn’t receive OTP? `, typeDLS: TypographyTypeDLS.B2R }),
                    React.createElement(Typography, { label: `Resend`, typeDLS: TypographyTypeDLS.B2S, color: ColorTokens.Primary_100 })))
            :
                React.createElement(Typography, { label: `Didn’t receive OTP? Resend in ${resendTimer} secs`, typeDLS: TypographyTypeDLS.B2R }),
        React.createElement(View, { style: {
                height: 150
            } }),
        React.createElement(View, { style: {
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center'
            } },
            React.createElement(View, { style: {
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'center'
                } },
                React.createElement(Icon, { name: IconTokens.SecureIcon, size: IconSizeTokens.XXL }),
                React.createElement(Space, { size: SizeTypeTokens.SM }),
                React.createElement(Typography, { label: 'Powered by MFCentral', typeDLS: TypographyTypeDLS.B3R, color: ColorTokens.Grey_Night })))));
};
const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    },
};
export default CgtcOtpPage;
